import { useTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Form from "ui/atom/Form";
import Button from "ui/base/Button";
import Page from "ui/Page";

import { useApplication } from "../fabric";
import Card from "ui/base/Card";


export default function Application() {
	const { back, data, mutation, form, isPending } = useApplication();
	const theme = useTheme();
	const verified = data?.contact.emailVerified;

	const style = {
		success: {
			display: mutation.isSuccess ? "flex" : "none",
			transition: "all 500ms ease"
		},
		error: {
			display: mutation.error ? "flex" : "none",
			transition: "all 500ms ease"
		}
	} as SxProps;

	return (
		<Page maxWidth="sm">
			<Page.Body>
				<Alert id="success-alert" variant="filled" color="success" severity="success" sx={style.success}>
					Partner updated
				</Alert>
				<Alert id="error-alert" variant="filled" color="error" severity="error" sx={style.error}>
					{mutation.error?.message}
				</Alert>
				<Card>
					<Card.Header
						title="Review Application"
						action={
							<Box gap={1}>
								<Button.Icon icon="thumbs-down" color="error" loading={isPending} onClick={() => form.handleSubmit({ type: "reject" })} />
								<Button.Icon icon="thumbs-up" color="success" loading={isPending} onClick={() => form.handleSubmit({ type: "approve" })} />
							</Box>
						}
					/>
					<Card.Content>
						<Form>
							<form.AppForm>
								<form.AppField name="contact.name" children={(field) => <field.Input label="Full Name" placeholder="Enter your full name" required />} />
								<form.AppField name="contact.title" children={(field) => <field.Input label="Title" placeholder="What is your role at the company? (ex. Circulation Manager)" required />} />
								<form.AppField name="contact.email" children={(field) => <field.Input label="Company Email" type="email" placeholder="Enter your company email address" endAdornment={<Icon name={verified ? "badge-check" : "badge"} color={verified ? theme.palette.success.main : theme.palette.text.disabled} />} required />} />
								<form.AppField name="contact.phone" children={(field) => <field.Phone label="Company Phone" type="tel" placeholder="Enter your company email address" />} />
								<form.AppField name="contact.company" children={(field) => <field.Input label="Company Name" placeholder="Enter your company’s name (ex. Times Publishing Co.)" required />} />

								<form.AppField name="partner.name" children={(field) => <field.Input label="Publication Name" placeholder="Enter your publication name (ex. The Bellevue Tribune)" required />} />
								<form.AppField name="partner.url" children={(field) => <field.Input label="Publication URL" type="url" placeholder="Enter your publication URL (ex. mypaper.com)" required />} />
							</form.AppForm>
							<Box.Column gap={1} sx={{ mt: 2 }}>
								<Box gap={1}>
									<Button variant="contained" color="error" loading={isPending} fullWidth onClick={back}>Cancel</Button>
									<Button variant="contained" color="success" loading={isPending} fullWidth onClick={() => form.handleSubmit({ type: "save" })}>Save</Button>
								</Box>

							</Box.Column>
						</Form>
					</Card.Content>
				</Card>
			</Page.Body>
		</Page>
	);
}